import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68d93de1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column align-items-center slot-container" }
const _hoisted_2 = {
  id: "fbx-damage-list",
  class: "damage-list"
}
const _hoisted_3 = {
  key: 0,
  class: "critical-damage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recordedTypes, (damage) => {
        return (_openBlock(), _createElementBlock("div", {
          key: damage?.type
        }, " - " + _toDisplayString(_ctx.listItemTitle(damage?.type)), 1))
      }), 128))
    ]),
    (_ctx.hasCriticalDamage && _ctx.includeCriticalDamageMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Please note that if this damage is still present and you decide to take this trailer, we will request that you get this trailer repaired in your possession. "))
      : _createCommentVNode("", true)
  ]))
}